export const MENUS_GET = 'MENUS_GET';
